export default __webpack_public_path__ + "static/media/icon_eyes_open.021230ea.svg";